<template>
  <div class="w3-content" style="max-width:90%">
    <h2 style="text-align: center;">Shipping Policy</h2>
    <br><br><br><br>
<b>SHIPPING POLICY</b><br><br>

Thank you for visiting and shopping at www.sanjeevanidairyfarms.com or www.doodhvale.com. Following are the terms and conditions that constitute our Shipping Policy.

<br><br><br><br>
<b>Shipment processing time</b><br><br>

Shipping time can vary as per the user selection at the time of checkout of products and it may get delayed because of various reasons like traffic conditions, reach ability conditions of buyers address, natural delay like rain etc but the company puts its best effort to delivery the products as per the time specified at the time of checkout. Orders are not shipped or delivered on holidays.<br><br>

If we are experiencing a high volume of orders, shipments may be delayed as mentioned at the time of products checkout. Please allow additional time in transit for delivery. If there will be a significant delay in shipment of your order, we will contact you via email or telephone.<br><br>

<br><br><br><br>
<b>Shipping rates & delivery estimates</b><br><br>

Shipping charges for your order will be calculated and displayed at the time of checkout.
  </div>
</template>
<script>
  // import axios from 'axios'
  export default {
    data () {
    },
    created () {
      var fullUrl = document.URL
      var splitUrl = fullUrl.split('r?')
      sessionStorage.setItem('urlstr', splitUrl[1])
    },
    methods: {
    }
  }
</script>
<style>
body {font-family: "Times New Roman", Georgia, Serif;}
h1, h2, h3, h4, h5, h6 {
  font-family: "Playfair Display";
  letter-spacing: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Shipping.vue